<template lang="html">
  <div>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">아이디</b-col>
      <b-col sm="5">
        <b-input-group v-if="newFlag == 'new'">
          <b-form-input key="new-id" v-model="reportManager.manager_id" placeholder="아이디"
            name="managerIdVali" :class="{error: errors.has(managerIdVali)}" v-validate="'required'"
            :disabled="idChecked"
            @input="resetIdCheck"
          ></b-form-input>
          <b-input-group-append>
            <b-button v-if="!idChecked" variant="primary" @click="checkIdDuplicate">중복확인</b-button>
            <b-button v-else variant="outline-secondary" @click="resetIdCheck">변경</b-button>
          </b-input-group-append>
        </b-input-group>
        <div v-if="newFlag == 'new'">
          <small v-if="idChecked" class="text-success"><i class="fa fa-check"></i> 사용 가능한 아이디입니다.</small>
          <small v-if="!idChecked && triedCheck" class="text-danger"><i class="fa fa-times"></i> 중복 확인이 필요합니다.</small>
        </div>
        
        <b-form-input v-if="newFlag == 'edit'" key="edit-id" v-model="reportManager.manager_id" placeholder="" readonly></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">이름</b-col>
      <b-col sm="5">
        <b-form-input v-model="reportManager.name" placeholder="이름"
          name="managerNameVali" :class="{error: errors.has(managerNameVali)}" v-validate="'required'"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">비밀번호</b-col>
      <b-col sm="5">
        <b-form-input v-model="reportManager.password" placeholder="비밀번호" type="password"
          name="passVali" :class="{error: errors.has(passVali)}" v-validate="newFlag === 'new' ? 'required' : ''" ref="password"
          autocomplete="new-password"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">비밀번호 확인</b-col>
      <b-col sm="5">
        <b-form-input v-model="reportManager.password2" placeholder="비밀번호 확인" type="password"
          name="pass2Vali" :class="{error: errors.has(pass2Vali)}" v-validate="newFlag === 'new' ? 'required' : ''"
          autocomplete="new-password"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel" >부서명</b-col>
      <b-col sm="5">
        <b-form-input v-model="reportManager.department" placeholder="부서명"
        name="divNameVali" :class="{error: errors.has(divNameVali)}" v-validate="'required'"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">이메일</b-col>
      <b-col sm="5">
        <b-form-input v-model="reportManager.email" placeholder="이메일"
          name="managerEmailVali" :class="{error: errors.has(managerEmailVali)}" v-validate="'required|email'"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">휴대폰번호</b-col>
      <b-col sm="5">
        <b-form-input v-model="reportManager.mobile" placeholder="휴대폰번호"  name="managerMobileVali"></b-form-input>
      </b-col>
    </b-row>
    <b-row class="pb-2" v-if="reportManager.authority != 'MNGR_ATHRT_1'">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-2 formLabel">상태</b-col>
      <b-col sm="5" class="mt-2">
        <b-form-group>
          <b-form-radio-group v-model="reportManager.status">
            <b-form-radio value="MNGR_STATUS_1">허용</b-form-radio>
            <b-form-radio value="MNGR_STATUS_2">만료</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">권한등급</b-col>
      <b-col sm="5">
        <b-form-select
          v-model="reportManager.authority"
          :value="1"
          :options="{ 'MNGR_ATHRT_3': '콘텐츠관리자', 'MNGR_ATHRT_2': '운영관리자', 'MNGR_ATHRT_1': '슈퍼관리자'}"
          id="inline-form-custom-select-pref1"
          @change="updateAccessMenu"
        >
        </b-form-select>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col sm="1"></b-col>
      <b-col sm="2" class="mt-1 formLabel">접근권한관리</b-col>
      <b-col sm="6">
        <b-form-checkbox-group v-model="reportManager.access_menu" :options="access_menu_option" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: {
    reportManager:{
    },
    newFlag:null,
  },
  data(){
    return {
      validationFinish : false,
      managerIdVali : 'managerIdVali',
      managerNameVali : 'managerNameVali',
      passVali : 'passVali',
      pass2Vali : 'pass2Vali',
      divNameVali : 'divNameVali',
      managerEmailVali : 'managerEmailVali',
      access_menu_option: [],
      // ID 중복확인 상태
      idChecked: false,
      triedCheck: false,
    }
  },

  mounted: function() {
    this.getMenuInfo();
  },
  watch: {
    // reportManager 객체 자체가 교체될 때만 감지 (모달 열릴 때 등)
    // deep: true 옵션을 제거하여 내부 속성 변경(비밀번호 입력 등) 시에는 트리거되지 않게 함
    reportManager(val) {
       this.resetIdCheck();
       
       if (this.newFlag === 'new') {
         // 초기 권한이 없을 경우 기본값 설정 (콘텐츠관리자)
        //  if (!val.authority) {
        //    this.$set(val, 'authority', 'MNGR_ATHRT_3');
        //  }
         // 메뉴 정보가 이미 로드되어 있다면 권한 설정 적용
         if (this.access_menu_option.length > 0) {
           this.updateAccessMenu(val.authority);
         }
       }
    }
  },
  methods:{
    // 메소드명 : validateCheckFN()
    // ### 관리자 폼(Form) 벨리데이션 ###
    // 관리자 폼 정보 제대로 입력했는지 검증
    // 부모 컴포넌트에서 실행
    //
    // 최초작성 : 2017.07.01
    // 파라미터 :
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.01  이승훈   최초작성
    // *************************
    validateCheckFN(){
      this.$validator.validateAll().then(res=>{
        // VeeValidate 결과가 false여도 실제 에러 메시지가 없다면(시스템적 오류/타이밍 이슈) 통과로 처리
        // items 배열의 길이를 직접 확인
        const hasNoErrors = !this.errors.items || this.errors.items.length === 0;
        const isTrulyValid = res || hasNoErrors;

        if(!isTrulyValid) {
          console.log('Validation truly failed. Errors:', this.errors);
        }

        // 비밀번호 일치 로직만 별도로 한번 더 체크
        const isPasswordMatch = (this.reportManager.password == this.reportManager.password2);
        
        // 아이디 중복확인 패스 여부 (신규일때만 필수)
        const isIdCheckPass = (this.newFlag !== 'new') || this.idChecked;

        // 비밀번호 복잡도 체크 (영문/숫자/특수문자 조합, 8자 이상)
        // Edit 모드일 때 비밀번호가 비어있으면(변경 안 함) 체크 안 함
        // New 모드이거나, Edit 모드인데 비밀번호가 입력된 경우에만 체크
        let isPasswordComplex = true;
        let isConsecutive = false;
        if (this.reportManager.password) {
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
            isPasswordComplex = passwordRegex.test(this.reportManager.password);
            
            // 3개 이상 연속되거나 동일한 문자/숫자 체크
            isConsecutive = this.checkConsecutive(this.reportManager.password);
        }

        if(isTrulyValid && isPasswordMatch && isIdCheckPass && isPasswordComplex && !isConsecutive) {
          this.reportManager.formValidation = true;
          this.validationFinish = true;
        } else {
          // 실패 원인 알림
          if (this.newFlag === 'new' && !isIdCheckPass) {
             swal.fire({
              type: 'warning',
              title: '아이디 중복확인을 해주세요.',
              showConfirmButton: false,
              timer: 1500
            });
          } else if (!isPasswordMatch) {
             swal.fire({
              type: 'warning',
              title: '비밀번호가 일치하지 않습니다.',
              showConfirmButton: false,
              timer: 1500
            });
          } else if (!isPasswordComplex) {
             swal.fire({
              type: 'warning',
              title: '비밀번호는 영문, 숫자, 특수문자를 포함하여 8자 이상이어야 합니다.',
              showConfirmButton: false,
              timer: 1500
            });
          } else if (isConsecutive) {
             swal.fire({
              type: 'warning',
              title: '비밀번호에 3개 이상 연속되거나 동일한 문자/숫자는 사용할 수 없습니다.',
              showConfirmButton: false,
              timer: 1500
            });
          }
           this.reportManager.formValidation = false;
           this.validationFinish = true;
        }
      })
    },

    resetIdCheck() {
      this.idChecked = false;
      this.triedCheck = false;
    },

    checkIdDuplicate() {
      if (!this.reportManager.manager_id) {
        swal.fire({
          type: 'warning',
          title: '아이디를 입력해주세요.',
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      
      // 이미 체크 완료된 상태라면 함수 종료 (혹은 변경 버튼으로직으로 이동)
      if (this.idChecked) return;

      // /select/user API 호출
      // 백엔드: @RequestMapping(value={"/select/user"}, method = RequestMethod.GET)
      this.$http.get('/select/user', {
        params: {
          username: this.reportManager.manager_id
        }
      }).then((result) => {
        // 결과가 있으면(객체가 리턴되면) 중복
        if (result.data) {
           swal.fire({
            type: 'warning',
            title: '이미 사용중인 아이디입니다.',
            showConfirmButton: false,
            timer: 1500
          });
          this.idChecked = false;
          this.triedCheck = true;
        } else {
           swal.fire({
            type: 'success',
            title: '사용 가능한 아이디입니다.',
            showConfirmButton: false,
            timer: 1500
          });
          this.idChecked = true;
          this.triedCheck = true;
        }
      }).catch(error => {
        console.error(error);
         swal.fire({
            type: 'error',
            title: '중복 확인 중 오류가 발생했습니다.',
            showConfirmButton: false,
            timer: 1500
          });
      })
    },

    getMenuInfo() {
      const token = sessionStorage.getItem("myToken");
      const self = this;
      this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=ACCESS_MENU')
        .then((result) => {
          let menuData = result.data;
          menuData.forEach(function (el, idx, arr){
            self.access_menu_option.push({text:el.item_name,value:el.item_code})
          });

          // 신규 등록시 초기 권한 설정에 맞춰 접근 권한 자동 체크
          if (self.newFlag == 'new' && self.reportManager.authority) {
            self.updateAccessMenu(self.reportManager.authority);
          }
        })
    },

    checkConsecutive(password) {
      if (!password) return false;

      // 1. 3개 이상 동일한 문자/숫자 (aaa, 111, !!!)
      if (/(\w)\1\1/.test(password)) {
        return true;
      }

      // 2. 3개 이상 연속된 문자/숫자 (abc, 123)
      for (let i = 0; i < password.length - 2; i++) {
        let char1 = password.charCodeAt(i);
        let char2 = password.charCodeAt(i + 1);
        let char3 = password.charCodeAt(i + 2);

        // 오름차순 (123, abc)
        if (char1 + 1 === char2 && char2 + 1 === char3) {
          return true;
        }
      }
      
      return false;
    },

    updateAccessMenu(authority) {
      if (!authority) return;
      
      if (authority === 'MNGR_ATHRT_1') {
        // 슈퍼관리자: 전체 체크
        this.reportManager.access_menu = this.access_menu_option.map(option => option.value);
      } else if (authority === 'MNGR_ATHRT_2') {
        // 운영관리자: 공통관리(ACCESS_MENU_9) 제외 전체
        this.reportManager.access_menu = ['ACCESS_MENU_1', 'ACCESS_MENU_2', 'ACCESS_MENU_3', 'ACCESS_MENU_4', 'ACCESS_MENU_5', 'ACCESS_MENU_6', 'ACCESS_MENU_7', 'ACCESS_MENU_8', 'ACCESS_MENU_10'];
      } else if (authority === 'MNGR_ATHRT_3') {
        // 콘텐츠관리자: 콘텐츠관리(ACCESS_MENU_2), 상품관리(ACCESS_MENU_5)만
        this.reportManager.access_menu = ['ACCESS_MENU_2', 'ACCESS_MENU_5'];
      }
    },
  }
}
</script>


<style scoped>
.formLabel{
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/common/manager/component/ManagerFormModal.vue